import { render, staticRenderFns } from "./deleteDriver.vue?vue&type=template&id=1d47b22c&"
import script from "./deleteDriver.vue?vue&type=script&lang=js&"
export * from "./deleteDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports